import styled from 'styled-components'

import { helpers } from 'styles'

export const HeaderWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin: ${helpers.spacing.xxLarge} 0;
`
